import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box, Radio, Dialog } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import axios, { Axios } from 'axios';
import { BASE_URL } from '../../../../../utils';
import * as Yup from 'yup';
import {
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { PriceListTable } from './LisPriceListTable';


const BILL_TABLE_HEADER = [
  {
    header: 'Test',
    accessor: (row) => row?.testData?.test_name
  },

  {
    header: 'OPD Charge',
    accessor: ''
  },
  {
    header: 'Ipd Charge',
    accessor: ''
  },

  {
    header: 'NABH Opd Char',
    accessor: ''
  },
  {
    header: 'NABH Ipd Char',
    accessor: ''
  },

  {
    header: 'Def Disc',
    accessor: ''
  }
];

const initialInvestiagtionBookingDataObj = {
  data: [],
  loading: false
};

export const LisPriceListMaster = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const user = JSON.parse(localStorage.getItem('user'));
  const [selectedRadio, setSelectedRadio] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedRadioCheak, setSelectedRadioCheak] = useState(false);
  const [selectedSponser, setSelectedSponser] = useState(null);
  const [selectedSponserCheak, setSelectedSponserCheak] = useState(false);
  const [selectedMainGroup, setSelectedMainGroup] = useState(null);
  const [selectedMainGroupCheak, setSelectedMainGroupCheake] = useState(false);
  const [selectedSubGroup, setSelectedSubGroup] = useState(null);
  const [selectedSubGroupFilter, setSelectedSubGroupFilter] = useState(null);
  const [selectedSubGroupcheak, setSelectedSubGroupCheak] = useState(false);
  const [groupDropdown, setGroupDropdown] = useState([]);
  const [subGroupDropdown, setSubGroupDropdown] = useState([]);
  const [serviceDropdown, setServiceDropdown] = useState([]);
  const [sponsorDropdown, setSponosrDropdown] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [priceListData, setPriceListData] = useState([]);
  const [addPriceListNameDialogue, setAddPriceListNameDialogue] = useState([]);
  const [issLoading, setIssLoading] = useState(false); // Track loading state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10
  });
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      effective_date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, reset, setValue, watch } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord?.service_items?.filter((item) => item.sample_collected === false));
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getGroupData = useCallback(async () => {
    const data = await dropdownFetch('test-main-group');
    setGroupDropdown(data);
  }, []);

  const getSubGroupData = useCallback(async () => {
    if (selectedMainGroup) {
      const data = await dropdownFetch('test-sub-group');
      const filteredData = data.filter((item) => item.main_group === selectedSubGroupFilter);
      setSubGroupDropdown(filteredData);
    }
  }, [selectedMainGroup]);

  const getSponsorData = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    // if (!selectedRecord) {
    //   const [defaultSponsor] = data.filter(({ status }) => status === 'default');
    //   setValue('price_list_name', defaultSponsor?._id);
    // }
    setSponosrDropdown(data);
  }, []);

  const getServiceData = useCallback(
    async (currentPage, selectedSponser, selectedMainGroup, selectedSubGroup) => {
      if (selectedSponserCheak && selectedMainGroupCheak && selectedSubGroupcheak) {
        setIssLoading(true);
        try {
          const response = await axios.get(
            `${BASE_URL}/lab-price-list-master/list?page=${currentPage}&sponsorName=${selectedSponser}&mainGroupName=${selectedMainGroup}&subGroupName=${selectedSubGroup}`
          );
          const { data: newData, pagination: newPagination } = response.data;
          setServiceDropdown((prevData) => [...prevData, ...newData]);
          setPagination(newPagination);
        } catch (error) {
          console.error('Error fetching service data:', error);
        } finally {
          setIssLoading(false);
        }
      }
    },
    [selectedSponserCheak, selectedMainGroupCheak, selectedSubGroupcheak]
  );

  const fetchMoreData = (currentPage, selectedSponser, selectedMainGroup, selectedSubGroup) => {
    if (!issLoading) {
      getServiceData(currentPage, selectedSponser, selectedMainGroup, selectedSubGroup);
    }
  };

  useEffect(() => {
    fetchMoreData(1, selectedSponser, selectedMainGroup, selectedSubGroup);
  }, [ selectedSponser, selectedMainGroup, selectedSubGroup]);

  useEffect(() => {
    getGroupData();
  }, [getGroupData]);

  useEffect(() => {
    getSubGroupData();
  }, [getSubGroupData]);

  useEffect(() => {
    getSponsorData();
  }, [getSponsorData]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    const updatedData = selectedRows.map((row) => {
      const modifiedInputValues = row.inputValues.map((inputValue) => ({
        ...inputValue // Include updated fields
      }));

      return {
        inputValues: modifiedInputValues
      };
    });

    // const payload = {
    //   price_list_name: formValues.price_list_name,
    //   inputValues: updatedData,
    // };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/lab-price-list-master-edit' : '/lab-price-list-master-create', {
      method: editFlag ? 'PUT' : 'PUT',
      params: editFlag ? selectedRecord._id : null,
      body: {
        price_list_name: formValues.price_list_name,
        updatedData,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Price List Master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setSelectedSponser(null);
      setSelectedMainGroup(null);
      setSelectedSubGroup(null);
      setSelectedRows([]);
      setServiceDropdown([]);
      
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Price List Master`, { variant: 'error' });
    }
    setLoading(false);
  };



  const handleSponserIndentChange = (event) => {
    const { value } = event.target;
    console.log(value);
    setServiceDropdown([]);
    setSelectedSponserCheak(true);
    setSelectedSponser(value);
  };

  const handlegroupIndentChange = (event) => {
    const { value } = event.target;

    setSelectedSubGroupFilter(event.target.value);
    setServiceDropdown([]);
    setSelectedMainGroupCheake(true);
    setSelectedMainGroup(value);
  };

  const handlsubGroupIndentChange = (event) => {
    const { value } = event.target;

    console.log(value);
    setServiceDropdown([]);
    setSelectedSubGroupCheak(true);
    setSelectedSubGroup(value);
  };

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        // Toggle selection state
        return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
      } else {
        // Add row to the selectedRows
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleInputChange = (e, rowId, header) => {
    const { value } = e.target;

    // Update the main data source
    setServiceDropdown((prevData) =>
      prevData.map((row) =>
        row._id === rowId
          ? {
            ...row,
            inputValues: row.inputValues.map((inputValue) =>
              inputValue.hasOwnProperty(header) ? { ...inputValue, [header]: value } : inputValue
            )
          }
          : row
      )
    );

    // Ensure selectedRows also reflects the updated value
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) =>
        row._id === rowId
          ? {
            ...row,
            inputValues: row.inputValues.map((inputValue) =>
              inputValue.hasOwnProperty(header) ? { ...inputValue, [header]: value } : inputValue
            )
          }
          : row
      )
    );
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
               Lab Price List Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Box
                  sx={{
                    border: '0px solid gray',
                    padding: 2,
                    borderRadius: '8px',
                    width: '100%',
                    boxShadow: '0px 2px 10px #0099ff'
                  }}
                >
                  <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor Name List</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.7 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="price_list_name"
                        placeholder="Select Price List Name"
                        menus={sponsorDropdown.map((data) => ({ ...data, name: data.name }))}
                        onChange={handleSponserIndentChange}
                      />
                      <Button
                        sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                        variant="contained"
                        onClick={() => setAddPriceListNameDialogue(true)}
                      >
                        <AddIcon />
                      </Button>
                    </Stack>
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Effective Date</Typography>
                      <TextField
                        sx={{ flex: 0.7 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="effective_date"
                        type="date"
                      />
                    </Stack>

                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Applied On</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.35 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="doctor"
                        placeholder="Select Doctor"
                      />
                      <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }} variant="contained">
                        <RemoveIcon />
                      </Button>
                      <SelectTag
                        formControlSX={{ flex: 0.35 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="doctor"
                        placeholder="Select Doctor"
                      />
                      <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }} variant="contained">
                        <AddIcon />
                      </Button>
                    </Stack>
                  </Stack>
                  <Stack spacing={0.2} direction="row" alignItems="center">
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Main Group</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.7 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="main_group"
                        menus={groupDropdown.map((data) => ({ ...data, name: data.main_group }))}
                        placeholder="Select Main Group"
                        onChange={handlegroupIndentChange}
                      />
                    </Stack>
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sub Group</Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.7 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="sub_group"
                        menus={subGroupDropdown.map((data) => ({ ...data, name: data.sub_group }))}
                        placeholder="Select Main Group First"
                        onChange={handlsubGroupIndentChange}
                      />
                    </Stack>
                  </Stack>
                </Box>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                >
                  <PriceListTable
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', minHeight: '30rem' }}
                    fetchMoreData={fetchMoreData}
                    selectedRadio={selectedRadio}
                    selectedSponser={selectedSponser}
                    selectedMainGroup={selectedMainGroup}
                    selectedSubGroup={selectedSubGroup}
                    showOk={true}
                    selectedRows={selectedRows}
                    handleRowSelect={handleRowSelect}
                    isSelected={isSelected}
                    issLoading={issLoading}
                    pagination={pagination}
                    data={currentAction === 'new' ? serviceDropdown : []}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showInputField={true}
                    handleInputChange={handleInputChange}
                    inputValues={inputValues}
                    onRowClick={(row) => {
                      setSelectedRecord(row);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
